import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router';
import { Theme } from '../../config/theme.js';

import MAGNIFYING_GLASS_ICON from './search.svg';

export default class SearchButton extends Component {
  render() {
    return (
      <div className={css(styles.container, !this.props.visible ? styles.hide_container : false)} onClick={this.props.handler.bind(this)}>
        <img src={MAGNIFYING_GLASS_ICON} className={css(styles.icon)} />
      </div>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    marginLeft: 40,
    marginRight: 30,
    height: 30,
    textAlign: 'center',
    cursor: 'pointer',
    opacity: 1,
    transition: 'all 180ms ease-in-out',
  },
  hide_container: {
    opacity: 0,
  },
  icon: {
    flex: 1,
    color: Theme.black,
    width: 20,
    height: 20,
  },
})



// WEBPACK FOOTER //
// ./src/components/SearchButton/index.js